import React from "react";
import { RedBorderSpan, GreenBorderSpan, YellowBorderSpan } from "../styled_components/divs";
import { moment } from "../../../../../vendor";
import t from "../../../helpers/t";


const availIcon = (props) => {

    const [endTime,setEndTime] = React.useState("");
    const [overwrite,setOverwrite] = React.useState(false);

    React.useEffect(() => {
        let timeout = null;
        const getDiffString = () => {
            if(typeof props.blockedEnd === 'undefined' || props.blockedEnd === null || props.Value !== "pending") return;
            let diffString = t("blocktime ends in") + " ";
            let blockedEnd = moment(props.blockedEnd).format("DD.MM.YY HH:mm:ss");

            let startDate = new Date(moment());
            let endDate = new Date(props.blockedEnd);
            let diff=Math.floor(endDate.getTime()/1000) - Math.floor(startDate.getTime()/1000);
            let days = 0,
                hours = 0,
                minutes = 0;
            if (diff >= (1440*60)) {
                days = Math.floor(diff / (1440 * 60));
                diff -= days * 1440 * 60;
            }
            if (diff >= 3600) {
                hours = Math.floor(diff / 3600);
                diff -= hours * 3600;
            }
            if (diff >= 60) {
                minutes = Math.floor(diff / 60);
                diff -= minutes * 60;
            }
            if (days > 0) {
                diffString += days + " " + t("days") + (hours > 0 || minutes > 0 || diff > 0 ? ", " : " ");
            }
            if (hours > 0) {
                diffString += hours + " " + (hours > 1 ? t("hours"): t("hour")) + (minutes > 0 || diff > 0 ? ", " : " ");
            }
            if (minutes > 0) {
                diffString += minutes + " " + (minutes > 1 ? t("minutes") : t("minute"))  + (diff > 0 ? ", " : " ");
            }
            if (diff > 0) {
                diffString += Math.floor(diff) + " " + (Math.floor(diff) > 1 ? t("seconds") : t('second')) + " ";
            }
            diffString += "(" + blockedEnd + ")";
            setEndTime(diffString);
            if(Math.floor(diff) <= 0 && hours <= 0 && minutes <= 0) return setOverwrite(true);
            timeout=setTimeout(getDiffString,1000);
        }
        getDiffString();
        return () => {
            clearTimeout(timeout);
        }
    },[]);

  if (props.Value === "available" || overwrite) {
    return (
      <>
        <a
          href="#"
          key={"icon_a_resource_button_avail_" + props.Resource.id}
          onClick={() => {
            props.setInitialized(false);
            window.location.replace("/reservations/reservationsList?resource_id=" + props.Resource);
          }}
        >
          <GreenBorderSpan title={endTime}>
            <i
              className="fi fi-torso torso"
              key={"icon_i_resource_button_avail_" + props.Resource.id}
            />
          </GreenBorderSpan>
        </a>
      </>
    );
  } else if (props.Value === "pending") {
    return (
      <>
        <a
          href="#"
          key={"icon2_a_resource_button_pend_" + props.Resource.id}
          onClick={() => {
            props.setInitialized(false);
            window.location.replace(
              "/reservations/reservationsList?reservation_id=" + props.Reservation,
            );
          }}
        >
          <YellowBorderSpan title={endTime}>
            <i
              className="fi fi-torso torso"
              key={"icon2_i_resource_button_avail_" + props.Resource.id}
            />
          </YellowBorderSpan>
        </a>
      </>
    );
  } else {
    return (
      <>
        <a
          href="#"
          key={"icon2_a_resource_button_notavail_" + props.Resource.id}
          onClick={() => {
            props.setInitialized(false);
            window.location.replace(
              props.Value === "inprogress"
                ? "/reservations/reservationsList?reservation_id=" + props.Reservation
                : "/reservations/reservationsList?resource_id=" + props.Resource,
            );
          }}
        >
          <RedBorderSpan title={endTime}>
            <i
              className="fi fi-torso torso"
              key={"icon2_i_resource_button_avail_" + props.Resource.id}
            />
          </RedBorderSpan>
        </a>
      </>
    );
  }
};

export default availIcon;
